<template>
    <div class="homepage" >
  
    </div>
</template>

<script>
import { mapState } from 'vuex';
//import { WFIcon, WFTranslate } from '@3dwayfinder/wayfinder-vue-components'


export default {
    components: {
        
        
    },
    props: {
        poi: {
            default: null,
            type: Object
        }
    },
	computed: {
		...mapState('wf', ['language']),
	}, 
    methods: {
        close () {
            console.log('popup.close')
            return () => {
                
                console.log('close')
                this.$emit("close")
            };
        },
    }
}
</script>
<style scoped>

</style>